import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useUserStore } from '../store/userStore';
import { AuraLogo } from './Brand';

export function StaffShell({ title, badge, children }) {
  const navigate = useNavigate();
  const { user, logout } = useUserStore();
  const doLogout = () => {
    logout();
    navigate('/login');
  };
  return (
    <div className="min-h-screen" style={{ background: 'var(--aura-navy-deep)' }}>
      <header className="sticky top-0 z-30 border-b border-white/10" style={{ background: 'rgba(11,11,31,0.85)', backdropFilter: 'blur(14px)' }}>
        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <AuraLogo size={38} />
            <div>
              <div className="font-display text-lg text-white leading-none">Auralis {title}</div>
              {badge && <div className="text-[10px] uppercase tracking-widest text-white/50 mt-1">{badge}</div>}
            </div>
          </div>
          <div className="flex items-center gap-3">
            <div className="hidden sm:block text-right">
              <div className="text-sm text-white font-medium">{user?.name}</div>
              <div className="text-xs text-white/50">{user?.email}</div>
            </div>
            <button data-testid="staff-logout-btn" onClick={doLogout} className="grid place-items-center w-9 h-9 rounded-full glass-dark text-white">
              <i className="fa-solid fa-arrow-right-from-bracket" />
            </button>
          </div>
        </div>
      </header>
      <main className="max-w-6xl mx-auto px-4 sm:px-6 py-8">{children}</main>
    </div>
  );
}
